const siteHeader = document.getElementById('siteHeader');
const backToTop = document.getElementById('backToTop');
const backToTopContainer = document.querySelector('.back-to-top');

if (backToTop && siteHeader) {
	// Click event
	backToTop.addEventListener('click', () => {
		siteHeader.scrollIntoView({ behavior: 'smooth' });
	});

	// Display on scroll
	window.addEventListener('scroll', () => {
		if (window.scrollY > window.innerHeight) {
			backToTopContainer.style.marginBottom = '0';
		} else {
			backToTopContainer.style.marginBottom = '-200px';
		}
	});
}
